import { render } from "./ReferenceInfoArchive.vue?vue&type=template&id=ddb6525a&scoped=true"
import script from "./ReferenceInfoArchive.vue?vue&type=script&lang=js"
export * from "./ReferenceInfoArchive.vue?vue&type=script&lang=js"

import "./ReferenceInfoArchive.vue?vue&type=style&index=0&id=ddb6525a&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddb6525a"]])

export default __exports__